import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import {
  DEFAULT_ICON_SIZE,
  getButtonClasses,
  type ButtonSize,
  type ButtonVariant,
} from "@/v2-backoffice-client/components/button/button.constants"
import { LICENSE_PLAYBOOK_URL } from "@/v2-backoffice-client/license/license.constants"

export type LicensePlaybookLinkProps = {
  variant?: ButtonVariant
  size?: ButtonSize
  className?: string
}

// The way into the operator playbook from every licensing surface: a link
// dressed as a button (the Button's own classes, so it sits next to Grant
// license and Create customer as an equal), opening in a new tab because the
// playbook is a reference read beside the panel, not a page in the app. The
// playbook is also where every pill is explained; the app carries no legend.
function LicensePlaybookLink(props: LicensePlaybookLinkProps) {
  const { variant = "secondary", size = "tiny", className } = props

  return (
    <a
      href={LICENSE_PLAYBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(getButtonClasses({ variant, size }), className)}
      title="How to give a customer access, limit it to named people and read what they get. Opens the operator playbook in a new tab."
      data-feature-code="UI_BackofficeLicensing_Playbook_Open"
    >
      <Icon src="book-open-reader" size={DEFAULT_ICON_SIZE} />
      Playbook
      <Icon src="arrow-up-right-from-square" size={9} className="opacity-70" />
    </a>
  )
}

export default LicensePlaybookLink
